import React from 'react';
import VideoSurveyRoom from '../VideoSurveyRoom';
import {
    getVideoClaimSession,
    subscribeVideoClaimSession,
    publishVideoClaimSession,
} from '@utils/videoClaimBus';

/**
 * 视频理赔通话房间的全局宿主。
 *
 * 挂在 App 层（与 VideoClaimIncoming 同级），生命周期与整个应用一致，
 * 因此在工单详情页里切换任意子标签、甚至临时离开详情页时都不会被卸载，
 * 通话不会中断。会话状态来自全局通道 videoClaimBus。
 *
 * 注意：本组件不要在 customerReception / 登录页等未连接 socket 的场景外使用；
 * VideoSurveyRoom 自身在非通话状态（INVITED/CALLING）会返回 null，
 * 来电阶段仍由全局 VideoClaimIncoming 弹窗负责。
 */
class VideoClaimRoomHost extends React.PureComponent {
    state = {
        session: getVideoClaimSession() || null,
    };

    componentDidMount() {
        // 同步一次最新值：App 挂载前通道里可能已经有会话了
        const session = getVideoClaimSession();
        if (session) this.setState({ session });
        this.unsubscribe = subscribeVideoClaimSession(this.handleBusSession);
    }

    componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
        this.unsubscribe = null;
    }

    handleBusSession = (session) => {
        this.setState({ session: session || null });
    };

    // 房间内部的会话变化（接听/客户进房/结束通话）统一回写全局通道，
    // 让工单详情等订阅方也能拿到最新状态并刷新按钮
    handleRoomSessionChanged = (session) => {
        publishVideoClaimSession(session);
    };

    render() {
        const { session } = this.state;
        if (!session) return null;
        return (
            <VideoSurveyRoom
                session={session}
                onSessionChanged={this.handleRoomSessionChanged}
                onSessionEnded={this.handleRoomSessionChanged}
            />
        );
    }
}

export default VideoClaimRoomHost;
